import React from 'react'
import {
  Button,
  Image,
  Input,
  Section,
  InputTextarea,
  Table,
  Modal,
  Checkbox,
  Tabber,
  DatePickerInput,
  SelectBox,
  Text,
  ToggleCompareEvent,
  Spinner,
} from '..'
const ConfirmModalRequestUnseal = ({
  modalsOpenConfirm,
  funcOpenModalConfirm,
}) => {
  const handleOnClickCancel = e => {
    funcOpenModalConfirm('request-unseal')
  }
  const handleOnClick = e => {
    funcOpenModalConfirm('submit')
  }
  return (
    <React.Fragment>
      <div>
        <Modal
          id="request_unseal"
          className="request_unseal theme-blue"
          classNameContainer="widthModal"
          isOpen={modalsOpenConfirm}
          modalWidth="575px"
        >
          <Modal.Header>Confirm</Modal.Header>
          <Modal.Body>
            <p className="default text-center">
              Are you sure to submit unseal request?
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleOnClickCancel} className="theme-border-gray">
              Cancel
            </Button>
            <Button className="theme-green" onClick={handleOnClick}>
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </React.Fragment>
  )
}
ConfirmModalRequestUnseal.defaultProps = {
  modalsOpen: false,
  funcOpenModalConfirm: () => {
    return false
  },
}
export default ConfirmModalRequestUnseal
